import type { BookingMode } from "@fm/api";

/** Shown next to the checkout button of a Request to Book vehicle. Keep it
 *  identical to the server's renter emails (`BookingRequestEmail`). */
export const REQUEST_TO_BOOK_BANK_NOTICE =
  "You won't be charged unless the fleet approves. Your bank may show a pending charge for several business days after a decline or expiry, and on a debit card those funds are held until it drops off.";

/** True when the vehicle's EFFECTIVE booking mode is `request`. */
export function isRequestToBook(
  vehicle: { booking_mode?: BookingMode | null } | null | undefined,
): boolean {
  return vehicle?.booking_mode === "request";
}

export interface CheckoutCopy {
  /** The step that creates the hold (before the payment form). */
  continueLabel: string;
  /** The Stripe form's submit button. */
  submitLabel: string;
  notice: string | null;
}

export function getCheckoutCopy(requestToBook: boolean): CheckoutCopy {
  if (requestToBook) {
    return {
      continueLabel: "Request to Book",
      submitLabel: "Request to Book",
      notice: REQUEST_TO_BOOK_BANK_NOTICE,
    };
  }

  return {
    continueLabel: "Continue to Payment",
    submitLabel: "Complete Reservation",
    notice: null,
  };
}
